import { render, staticRenderFns } from "./ReportGeneralInformation.vue?vue&type=template&id=f80e8c2e&lang=pug&"
import script from "./ReportGeneralInformation.vue?vue&type=script&lang=ts&"
export * from "./ReportGeneralInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ReportGeneralInformation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports